import React from 'react'
// components
import RiskView from 'components/PageComponents/Risks/Register/components/RiskView'
// layers
import RiskViewAPIProvider from './layers/API'

const RiskViewContainer = () => (
  <RiskViewAPIProvider>
    <RiskView />
  </RiskViewAPIProvider>
)

export default RiskViewContainer
